module.exports = __webpack_public_path__ + "img/TravelersTwoBags.4ad4a51c.png";